<h3 class="bold mt-huge-r">Default buttons</h3>
<section class="mt-regular-r">
  <p class="font-curve-regular light">
    Use these buttons in most situations. If you don't want the animation, you can leave out the
    <code>.btn-animated</code>
    class.
  </p>
  <app-default-buttons #defaultButtons class="d-flex gap-small-r flex-column"></app-default-buttons>
  <code
    class="block mt-regular-r"
    [highlight]="defaultButtons.templateString | formatCode"
    [languages]="['html']"
  ></code>

  <h3 class="bold mt-huge-r">Disabled buttons</h3>
  <div class="light font-curve-regular mt-regular-r alert alert-warning">
    <h4 class="bold font-curve-regular">Accessibility</h4>
    <p>Disabled controls are an accessibility anti-pattern for various reasons:</p>
    <ol class="my-regular">
      <li>
        They are not focussable, screen reader users or keyboard users cannot focus the button and
        might miss information that is hidden e.g. in a tooltip.
      </li>
      <li>The color contrast of disabled button is very low.</li>
    </ol>
    <p>
      Try to avoid disabled buttons by displaying an error message for invalid forms or hiding the
      control if a user cannot perform a certain action.
    </p>
  </div>
  <app-button-disabled
    #disabledButtons
    class="d-flex flex-column gap-small-r"
  ></app-button-disabled>
  <code
    class="block mt-regular-r"
    [highlight]="disabledButtons.templateString | formatCode"
    [languages]="['html']"
  ></code>
</section>

<h3 class="bold mt-huge-r">Animated</h3>
<section class="mt-regular-r">
  <div class="alert alert-info"><p>The animated buttons need a span around the text!</p></div>
  <app-animated-buttons
    class="d-flex flex-wrap align-items-center gap-small-r"
    #animatedButtons
  ></app-animated-buttons>
  <code
    class="block mt-regular-r"
    [highlight]="animatedButtons.elementRef.nativeElement.innerHTML | formatCode"
    [languages]="['html']"
  ></code>
</section>

<h3 class="bold mt-huge-r">Supported button tags</h3>
<section class="mt-regular-r">
  <app-button-tags #buttonTags class="d-flex flex-wrap gap-small-r"></app-button-tags>
  <code
    class="block mt-regular-r"
    [highlight]="buttonTags.elementRef.nativeElement.innerHTML | formatCode"
    [languages]="['html']"
  ></code>
</section>

<h3 class="bold mt-huge-r">Sizes</h3>
<section class="mt-regular-r">
  <app-button-sizes
    #buttonsizes
    class="d-flex flex-wrap align-items-center gap-small-r"
  ></app-button-sizes>
  <code
    class="block mt-regular-r"
    [highlight]="buttonsizes.elementRef.nativeElement.innerHTML | formatCode"
    [languages]="['html']"
  ></code>
</section>

<h3 class="bold mt-huge-r">Icon buttons</h3>
<section class="mt-regular-r">
  <app-icon-buttons
    #iconButtons
    class="d-flex flex-wrap align-items-center gap-small-r"
  ></app-icon-buttons>
  <code
    class="block mt-regular-r"
    [highlight]="iconButtons.elementRef.nativeElement.innerHTML | formatCode"
    [languages]="['html']"
  ></code>
</section>

<h3 class="bold mt-huge-r">Icon buttons with text</h3>
<div class="alert alert-info">
  <p>
    Icon buttons with text should not have the class
    <code>.btn-icon</code>
    , otherwise the horizontal padding is not correct.
  </p>
</div>
<section class="mt-regular-r">
  <app-icon-buttons-text #iconButtonsText class=""></app-icon-buttons-text>
  <code
    class="block mt-regular-r"
    [highlight]="iconButtonsText.elementRef.nativeElement.innerHTML | formatCode"
    [languages]="['html']"
  ></code>
</section>

<h3 class="bold mt-huge-r">Accent colors</h3>
<section class="mt-regular-r">
  <app-accent-buttons #accentButtons class="d-flex gap-small-r flex-wrap"></app-accent-buttons>
  <code
    class="block mt-regular-r"
    [highlight]="accentButtons.elementRef.nativeElement.innerHTML | formatCode"
    [languages]="['html']"
  ></code>
</section>

<h3 class="bold mt-huge-r">Inverted buttons</h3>
<p class="light font-curve-regular">
  Inverted buttons don't need special classes anymore, just use any of the
  <a routerLink="/bootstrap-samples/background">background classes</a>
  to set the background and you're done for the day.
</p>
<section class="mt-regular-r">
  <div class="bg-aubergine p-regular-r">
    <app-inverted-buttons
      #invertedButtons
      class="d-flex gap-small-r flex-wrap"
    ></app-inverted-buttons>
  </div>
  <code
    class="block mt-regular-r"
    [highlight]="invertedButtons.elementRef.nativeElement.innerHTML | formatCode"
    [languages]="['html']"
  ></code>
</section>

<h3 class="bold mt-huge-r">Contextual Buttons</h3>
<section class="mt-regular-r">
  <div class="alert-container">
    <div class="alert alert-danger">
      <p>These are only allowed for intranet applications! The link button cannot be animated.</p>
    </div>
  </div>
  <app-contextual-buttons
    #contextualButtons
    class="d-flex gap-small-r flex-wrap"
  ></app-contextual-buttons>
  <code
    class="block mt-regular-r"
    [highlight]="contextualButtons.elementRef.nativeElement.innerHTML | formatCode"
    [languages]="['html']"
  ></code>
</section>
